import { Component, OnInit, Input } from '@angular/core'
import { FormArray, FormGroup, FormControl } from '@angular/forms'
import { AbstractControl } from '@angular/forms'
import { IFlowOrAmendment, ensureFlowOrAmendment, FlowOrAmendment, addToFormArray, removeLastFormArray } from 'app/shared/utils';
import { IInputVehicleDetailsRow } from 'app/vehicles/vehicles-details-row/vehicles-details-row.component';
import { IVehicle, ITrailer } from 'app/vehicles/vehicles.interfaces';

@Component({
    selector: 'sbw-vehicles-details-rows',
    templateUrl: './vehicles-details-rows.component.html',
    styleUrls: ['./vehicles-details-rows.component.css']
})
export class VehiclesDetailsRowsComponent implements OnInit, IFlowOrAmendment {
    @Input() model: IInputVehicleDetailsRows
    @Input() mode: FlowOrAmendment
    @Input() countControl: AbstractControl

    @Input() selectedVehicleControl: FormControl
    @Input() selectedTrailerControl: FormControl

    registrations = new FormArray([])
    inputDetailsRows: IInputVehicleDetailsRow[] = []

    constructor() { }

    ngOnInit() {
        ensureFlowOrAmendment(this.mode)
        const form = <FormGroup>this.model.form
        form.addControl('vehicles', this.registrations)
        this.inputDetailsRows = this.model.vehicles
    }

    useFlow() { }

    useAmendment() { }

    rowCreated(group: FormGroup) {
        setTimeout(() => addToFormArray(this.registrations, group))
    }

    rowDestroyed(group: FormGroup) {
        setTimeout(() => removeLastFormArray(this.registrations))
    }
}

export interface IInputVehicleDetailsRows {
    form: AbstractControl
    vehicles: IInputVehicleDetailsRow[]
}

